module.exports = __webpack_public_path__ + "static/golden2-ca2ad8c64d9cc1dcf50f1194734041ed.png";